import gql from 'graphql-tag';

export default gql`
  query GetApplication($id: ID!) {
    application(id: $id) {
      id
      createdAt
      updatedAt
      fields
      status
      type
      document {
        id
        original
      }
      stakeholder {
        id
        firstName
        lastName
        idNumber
        cellNumber
        country
        dob
        email
      }
      property {
        address
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetApplication.ts